import { useIntl } from 'react-intl';
import ListSubheader from '@mui/material/ListSubheader';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

/**
 * The list itself — one place, so a cell and a form field offer the same thing.
 *
 * Rendered as `variant="menu"`, NOT MUI's default `selectedMenu`: the focus has
 * to land on the FIRST entry — the newest — whether or not the field already
 * holds one of the others. Enter therefore always means "the last one I used".
 * The value the field currently holds is still marked.
 */
export function RecentValuesMenu({
    anchor,
    values,
    current,
    onPick,
    onClose
}: {
    anchor: HTMLElement | null;
    values: readonly string[];
    /** What the field holds now — marked, never overwritten by the list. */
    current: string;
    onPick: (value: string) => void;
    onClose: () => void;
}) {
    const intl = useIntl();
    return (
        <Menu
            open={Boolean(anchor)}
            anchorEl={anchor}
            onClose={onClose}
            variant="menu"
            autoFocus
            slotProps={{ list: { dense: true, autoFocusItem: true } }}
        >
            <ListSubheader sx={{ lineHeight: 2, bgcolor: 'transparent' }}>
                {intl.formatMessage({ id: 'recent.title' })}
            </ListSubheader>
            {values.map((entry) => (
                <MenuItem
                    key={entry}
                    selected={entry === current.trim()}
                    onClick={() => onPick(entry)}
                >
                    {entry}
                </MenuItem>
            ))}
        </Menu>
    );
}
